export default __webpack_public_path__ + "media/move-weight-loss-no-med.c62815c478c91d7e2c9a76ae14852ac0.webp";